var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCopy = function SvgIconCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M0 8v8c0 2.21 1.807 4 3.976 4h7.952c2.289 0 4.096-1.79 4.096-4C18.193 16 20 14.21 20 12V4.001C20 1.791 18.193 0 16.024 0H7.952C5.783 0 3.976 1.791 3.976 4.001c-2.169 0-3.976 1.79-3.976 4m6.024-3.999h5.904c2.289 0 4.096 1.79 4.096 4v6c1.084 0 1.928-.896 1.928-2V4c0-1.105-.844-2-1.928-2H7.952c-1.085 0-1.928.895-1.928 2m-2.048 14c-1.084 0-2.048-.896-2.048-2V8c0-1.105.964-2 2.048-2h7.952c1.205 0 2.048.895 2.048 2v8c0 1.104-.843 2-2.048 2z"
  })));
};
export default SvgIconCopy;